/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  SET_APP_STATE,
  SET_FINGERPRINT,
  IAppState,
  SET_IS_MOBILE,
} from "actions/appStateActions";

const initialState: IAppState = {
  loading: false,
  fingerprint: "",
  isMobile: false,
};

const reduceAppState = (state: IAppState, action: any): IAppState => {
  if (action.type === SET_APP_STATE) {
    return {
      ...state,
      ...action.payload,
    };
  } else if (action.type === SET_FINGERPRINT) {
    return {
      ...state,
      fingerprint: action.payload,
    };
  } else if (action.type === SET_IS_MOBILE) {
    return {
      ...state,
      isMobile: action.payload,
    };
  } else {
    return state;
  }
};

export const appStateReducer = (
  state = initialState,
  action: any
): IAppState => {
  const newState = reduceAppState(state, action);
  return newState;
};

export default appStateReducer;
